import { ClockCircleOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import ManualBooking from "./ManualBooking";

import "./PartnerBooking.css";
import useDeliveryStore from "../../store/DeliveryStore";

const AVAILABLE_PARTNERS = [
  { label: "ShipRocket", value: "shiprocket" },
  { label: "ProRouting", value: "prorouting" },
  { label: "Pidge", value: "pidge" },
  { label: "All Three", value: "multi" },
];

export function BookPartner({ placed_order_id, attempts }) {
  const { loading, createRecord } = useDeliveryStore();

  return (
    <>
      <Row gutter={[12, 24]}>
        {AVAILABLE_PARTNERS.map((partner) => {
          return (
            <Col xs={12} md={6} key={partner.value}>
              <Button
                type="primary"
                className={`${partner.value}-btn`}
                icon={<ClockCircleOutlined />}
                loading={loading}
                onClick={() =>
                  createRecord({
                    id: placed_order_id,
                    partner: partner.value,
                    delivery_attempts: attempts,
                  })
                }
                style={{ width: "100%" }}
              >
                Book {partner.label}
              </Button>
            </Col>
          );
        })}
        <Col xs={12} md={6}>
          <ManualBooking
            orderId={placed_order_id}
            onSuccess={(initiatorDetails) =>
              createRecord({
                id: placed_order_id,
                partner: "manual",
                initiator: initiatorDetails,
                delivery_attempts: attempts,
              })
            }
          />
        </Col>
      </Row>
    </>
  );
}
